import { useRef } from "react";
import { Box, Button, Flex, Input, Text } from "@/ui";
import NavigationBar from "@/components/NavigationBar";
import { t } from "@/utils";
import { SuggestionIconMap } from "@/enums/camera";
import type { WizardProps } from "../Wizard";

const SUGGESTION_COUNT = 14;

export default function CameraName({ next, previous, state }: WizardProps<{ cameraName: string }>) {
  const nameRef = useRef<HTMLInputElement>(null);
  const suggestionKeyRef = useRef<string | null>(null);

  const suggestions = Array.from({ length: SUGGESTION_COUNT }).map((_, index) => ({
    value: t(`suggestion${index + 1}` as StringKey),
    key: `suggestion${index + 1}`
  }));

  return (
    <Flex grow={1} direction="column" alignItems="center">
      <NavigationBar title={t("cameraCustomization.step1.title")} props={{ mb: "8" }} />
      <Input
        mt="62"
        mb="32"
        px="1.5rem"
        py="1rem"
        defaultValue={state.cameraName || t("myCamera")}
        ref={nameRef}
        type="text"
        onChange={() => (suggestionKeyRef.current = null)}
      />
      <Text variant="label" alignSelf="flex-start" mb="16" color="on-surface">
        {t("suggestions")}
      </Text>
      <Flex flexWrap="wrap" gap="8">
        {suggestions.map(({ key, value }) => (
          <Button
            key={value}
            variant="unstyled"
            px="16"
            py="8"
            bg="secondary-container"
            fontWeight={400}
            onClick={() => {
              nameRef.current && (nameRef.current.value = value);
              suggestionKeyRef.current = key;
            }}
          >
            <Text variant="label" color="on-surface-variant">
              {value}
            </Text>
          </Button>
        ))}
      </Flex>
      <Box flexGrow={1} />
      <Button
        mt="48"
        bg="primary"
        color="on-primary"
        minW="18.5rem"
        onClick={() =>
          next({
            stateUpdate: {
              cameraName: nameRef.current?.value,
              cameraIcon: suggestionKeyRef.current ? SuggestionIconMap[suggestionKeyRef.current] : null
            }
          })
        }
      >
        {t("buttons.continue")}
      </Button>
    </Flex>
  );
}
